import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// CSRF: a custom header a cross-site page cannot set on a credentialed request.
// The backend rejects cookie-authenticated writes that lack it.
api.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Cache-bust every GET so mobile browsers / installed PWAs can never serve a stale
// response from their HTTP cache (this was showing an old members list on phones).
// A unique `_ts` makes each request URL distinct, forcing a fresh network fetch.
api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _ts: Date.now() };
    config.headers = {
      ...(config.headers || {}),
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    };
  }
  return config;
});
